import React, { useState } from 'react';
import { gql, useQuery } from '@apollo/client';

import { Form } from 'react-bulma-components';
import { Loader } from '../components';

const { Select } = Form;

export const GET_SONGREVISIONS = gql`
  query GetSongRevisions($slug: String!) {
    songRevisions(slug: $slug){
        id
        saved
        comment
    }
  }
`;



const RevisionPicker = ({slug, value, onChange}) => {
  //const [revisionId, setRevisionId] = useState(value);
  const { data, loading, error } = useQuery(
    GET_SONGREVISIONS,
    { 
      variables: { slug: slug },
      fetchPolicy: "cache-and-network" 
    }
  ); 

/*   const handleRevisionChange = (e) => {
    setRevisionId(e.target.value);
  }; */

  if (error) return <p>ERROR {error.message}</p>;
  if (loading) return (
    <Loader />
  );
  return (
    <Select onChange={(e) => onChange(e.target.value)} name="revision" value={value}>
       {data.songRevisions && data.songRevisions.map(revision =>
          <option key={revision.id} value={revision.id}>{`${new Date(revision.saved).toLocaleString()} ${revision.comment?revision.comment:""}`}</option>
        )}
    </Select>
  )
}

export default RevisionPicker;